import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";
import authService from "src/services/authService";
import { toAppUrl } from "src/services/configService";
import ElasticService from "src/services/elasticService";
import { makeStyles } from "tss-react/mui";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { Theme, Typography } from "@mui/material";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    title: {
        color: theme.palette.emteria.link,
    },
}));

const LogoutPage = () => {
    const { classes } = useStyles();
    const { t } = useTranslation("pages");

    useEffect(() => {
        const logout = async () => {
            await authService.logout();
            ElasticService.updateUserContext();
            window.location.href = toAppUrl("/login");
        };
        void logout();
    }, []);

    return (
        <PageContainer className={classes.container}>
            <Typography variant="h4">{t("logoutPage.title")}</Typography>
        </PageContainer>
    );
};

export default withMetaDescription(LogoutPage, {
    title: i18next.t("pages:logoutPage.metaTitle"),
    description: i18next.t("pages:logoutPage.metaDescription"),
});
